import { useState } from "react";
import BodySimpleModalV3 from "../../common/modal/BodySimpleModalV3";
import classes from './WorkQToolTips.module.css';
import OutsideClickComponent from "../../fragments/OutsideClickComponent";

export default function WorkQToolTips({description}) {
    const [showDescription, setShowDescription] = useState(false)

    function showDescriptionHandler() {
        setShowDescription(true)
    }

    function closeDescriptionHandler() {
        setShowDescription(false)
    }

    return <div className={classes.info_button_container}>
        <BodySimpleModalV3 message="WorkQ Info">
            <button className={classes.info_button} onClick={showDescriptionHandler} disabled={showDescription}>
                <i className="ti ti-info-square-rounded"></i>
            </button>
        </BodySimpleModalV3>
        {showDescription && <OutsideClickComponent task={closeDescriptionHandler}>
            <div className={classes.description_container}>
                <button className={classes.close_button} onClick={closeDescriptionHandler}>
                    <i className="ti ti-x"></i>
                </button>
                <div dangerouslySetInnerHTML={{__html: description}}></div>
            </div>
        </OutsideClickComponent>}
    </div>
}